// Import Core
import { attributes } from '../../core/ids-attributes';

// Property names
const MENU_BUTTON_ATTRIBUTES = [
  'dropdown-icon',
  'formatter-width',
  attributes.ID,
  attributes.MENU
];

export { MENU_BUTTON_ATTRIBUTES };
